import { postJSON } from 'bv-fetch';

export default (locationData) => postJSON('/login_location_check', locationData);
